import React from 'react';
import planeIcon from './planeIcon.png'

const PlaneBreak = () => {
  return (
    <img
      src={planeIcon}
      alt="planeIcon"
      style={{
        width: 35,
        height: 'auto',
        margin: 10,
      }}
      />
  );
};

export default PlaneBreak;